<template>
    <div>
            <vs-row vs-w="12" v-if="this.currentTask">
                <vs-alert v-if="this.currentTask.denied" :active="this.currentTask.denied" class="mt-5" icon-pack="feather" icon="icon-alert-circle" color="danger">
                    {{$t("DeniedReason")}} {{this.currentTask.denied_reason}}
                </vs-alert>
                <vs-alert v-if="isProject" :active="isProject" class="mt-5" icon-pack="feather" icon="icon-alert-triangle" color="warning">
                    {{$t("Project")}}: {{projectName}}
                </vs-alert>
                <vs-alert v-if="currentTask.registration_terminal_task" class="mt-5" icon-pack="feather" icon="icon-alert-circle" color="success">
                    {{$t("RegistrationTerminalTask")}}
                </vs-alert>
                <vs-col vs-w="12" class="p-1" vs-sm="12">
                    <vs-row vs-w="12" vs-justify="space-between">
                        <vs-col vs-w="2" class="p-2" vs-sm="12" v-if="!currentTask.registration_terminal_task">
                            <vx-card>
                                <vs-alert :active="elapsedTime.length > 0 && taskStatus.status === 0" class="mt-2" icon-pack="feather" icon="icon-watch" color="success"> {{elapsedTime}} </vs-alert>
                                <vs-alert :active="taskStatus.status === 1" class="mt-2" color="danger"> {{$t("TaskIsPaused")}}! </vs-alert>
                                <vs-alert :active="currentTask.status === 4" class="mt-2" color="success"> {{$t("SentForConfirmation")}}! </vs-alert>
                                <vs-button style="float: left" icon-pack="feather" icon="icon-play" :disabled="!canEditTask" type="border" v-if="taskStatus.status === 1 && currentTask.status < 4" color="success" @click="continueWork" class="mt-6 mr-3"/>
                                <vs-button style="float: left" icon-pack="feather" icon="icon-play" :disabled="!canEditTask" type="border" v-if="taskStatus.status === 2 && currentTask.status < 4" color="success" @click="activeStartWorkPrompt = true" class="mt-6 mr-3"/>
                                <vs-button style="float: left" icon-pack="feather" icon="icon-pause" :disabled="!canEditTask" type="border" v-if="taskStatus.status === 0 && currentTask.status < 4" color="warning" @click="pauseWork" class="mt-6 mr-3"/>
                                <vs-button style="float: left" icon-pack="feather" icon="icon-square" :disabled="!canEditTask" type="border" v-if="(taskStatus.status === 0 || taskStatus.status === 1) && currentTask.status < 4" color="danger" @click="activeFinishWorkPrompt = true" class="mt-6 mr-3"/>
                                <vs-button style="float: left" icon="directions_car" :disabled="!canEditTask" type="border" v-if="(taskStatus.status === 2 || taskStatus.status === 1) && currentTask.status < 4" color="success" @click="openStartTransportPrompt" class="mt-6 mr-3"/>
                                <div style="clear:both;"></div>
                                <vs-button v-if="this.$store.getters.userData.id === currentTask.company_user_id && currentTask.status < 5 && taskStatus.status === 2" type="border" color="warning" @click="sendToConfirm" class="mt-3 mr-3 w-full" id="confirmButton">{{$t("SendToConfirm")}}</vs-button>
                                <vs-button v-if="currentTask.status > 0" id="previewButton" type="border" color="warning" @click="getPDFPreview" class="mt-3 w-full vs-con-loading__container">{{(currentTask.status < 5) ? $t("Preview") : $t("OpenPrintout")}}</vs-button>
                            </vx-card>
                            <vx-card class="mt-3" :title='this.$t("Tags")'>
                                <vs-button v-if="(this.$store.getters.userData.id === currentTask.company_user_id || $checkPermission(104)) && !editTags" size="small" color="success" icon-pack="feather" icon="icon-tag" type="border" style="float: left" class="mr-3 mt-3" @click="editTags = true" />
                                <div v-if="editTags">
                                    <v-select class="selectStyle" multiple style="width: 100%" :options="selectableTags" label="name" v-model="selectedTags">
                                        <template slot="option" slot-scope="option">
                                            <div style="display: flex">
                                                <vs-chip :color="option.color" style="margin: auto">
                                                    <p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
                                                </vs-chip>
                                            </div>
                                        </template>
                                    </v-select>
                                    <vs-button v-if="this.$store.getters.userData.id === currentTask.company_user_id || $checkPermission(104)" class="mt-3" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="saveTags" >{{$t("SaveTags")}}</vs-button>
                                </div>
                                <div v-else style="float: left">

                                    <vs-chip class="mr-3 mt-3" :color="item.color" :key="index" v-for="(item,index) in this.currentTask.tags">
                                        <p v-bind:style="{color: item.text_color}"><b>{{ item.name}}</b></p>
                                    </vs-chip>

                                </div>
                                <div style="clear:both;"></div>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-w="3" class="p-2" vs-sm="12">
                            <vx-card :title='this.currentTask.title'>
                                <h5>ID: #{{currentTask.company_task_id}}</h5>
                                <h6>{{$t('Deadline')}}: {{moment(currentTask.deadline).format('DD/MM/YYYY HH:mm')}}</h6>
                                <h6>{{$t('Adder')}}: {{(this.$store.getters.companyUsers[currentTask.user_added] === undefined || currentTask.user_added === 0) ? currentTask.user_added_name : $store.getters.companyUsers[currentTask.user_added].name}}</h6>
                                <br>
                                <p style="white-space: pre-wrap">{{this.currentTask.description}}</p>
                                <vs-button v-if="this.$store.getters.userData.id === currentTask.company_user_id && currentTask.status < 4" type="border" color="warning" @click="activeDescriptionPrompt = true" class="mt-3">{{$t("Edit")}}</vs-button>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-w="3" class="p-2" vs-sm="12" v-if="this.taskClient.id && !currentTask.registration_terminal_task">
                            <vx-card :title='$t("ClientData")'>
                                <h5>{{this.taskClient.name}}</h5>
                                <p>{{this.taskClient.address}}</p>
                                <p>{{this.taskClient.country}}</p>
                                <br>
                                <div style="clear: left; display: flex" v-if="branchOffice">
                                    <p style="float: left"><b>{{$t("BranchOffice")}}: </b></p>
                                    <p style="float: left" class="ml-3">{{branchOffice.title}}</p>
                                </div>

                                <div style="clear: left; display: flex" v-if="contactsMap[currentTask.client_company_contact_id] !== undefined">
                                    <p style="float: left"><b>{{$t("Contact")}}: </b></p>
                                    <p style="float: left" class="ml-3">{{contactsMap[currentTask.client_company_contact_id].name + " " + contactsMap[currentTask.client_company_contact_id].l_name}}</p>
                                </div>
                                <div style="clear: left; display: flex" v-if="contactsMap[currentTask.client_company_contact_id] !== undefined">
                                    <p style="float: left"><b>{{$t("Email")}}: </b></p>
                                    <p style="float: left" class="ml-3">{{contactsMap[currentTask.client_company_contact_id].email}}</p>
                                </div>
                                <div style="clear: left; display: flex" v-if="contactsMap[currentTask.client_company_contact_id] !== undefined">
                                    <p style="float: left"><b>{{$t("PhoneNumber")}}: </b></p>
                                    <p style="float: left" class="ml-3">{{contactsMap[currentTask.client_company_contact_id].phone}}</p>
                                </div>

                                <vs-button v-if="this.$store.getters.userData.id === currentTask.company_user_id && currentTask.status < 5" type="border" color="warning" @click="activeEditContactPrompt = true" class="mt-3 mr-3">{{(currentTask.client_company_contact_id === 0) ? $t("AddContact") : $t("EditContact")}}</vs-button>
                                <vs-button v-if="this.$store.getters.userData.id === currentTask.company_user_id && currentTask.status < 5 && !isProject" type="border" color="warning" @click="activeEditClientPrompt = true" class="mt-3">{{$t("ChangeClient")}}</vs-button>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-w="4" class="p-2" vs-sm="12" v-if="this.taskClient.id && !currentTask.registration_terminal_task">
                            <vx-card :title='$t("AssignedUsers")'>
                                <vs-button v-if="currentTask.company_user_id === 0" type="border" color="success" @click="takeTask">{{$t("TakeTask")}}</vs-button>
                                <vs-button v-else-if="(this.$store.getters.userData.id === currentTask.company_user_id || $checkPermission(106)) && currentTask.status < 4" type="border" color="warning" @click="activeAssignUserPrompt = true" >{{$t("Add")}}</vs-button>
                                <vs-button v-else-if="currentTask.status == 1 && $checkPermission(108)" type="border" color="warning" @click="stealTask" >{{$t("StealTask")}}</vs-button>
                                <div class="mt-6" v-if="currentTask.company_user_id !== 0">
                                    <vs-table :data="assignedUsers">
                                        <template slot="thead">
                                            <vs-th>{{$t("Name")}}</vs-th>
                                            <vs-th v-if="$store.getters.userData.id === currentTask.company_user_id || $checkPermission(106)"></vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr>
                                                <vs-td :data="$store.getters.companyUsers[currentTask.company_user_id].name">
                                                    {{$store.getters.companyUsers[currentTask.company_user_id].name}}
                                                </vs-td>
                                                <vs-td></vs-td>
                                            </vs-tr>
                                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                                <vs-td :data="data[indextr].name + ' ' + data[indextr].l_name">
                                                    {{data[indextr].name + ' ' + data[indextr].l_name}}
                                                </vs-td>

                                                <vs-td v-if="($store.getters.userData.id === currentTask.company_user_id || $checkPermission(106)) && currentTask.status < 4">
                                                    <vs-button style="float:left;" class="mr-3" type="border" color="success" icon-pack="feather" icon="icon-award" @click="giveTaskId = data[indextr].user_id; activeGiveTaskPrompt = true"></vs-button>
                                                    <vs-button style="float:left;" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeFromTask(data[indextr].user_id)"></vs-button>
                                                </vs-td>
                                                <vs-td v-else></vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-w="12" class="p-2" v-if="this.taskClient.id && !currentTask.registration_terminal_task">
                            <vx-card>
                                <template slot="no-body">
                                    <vs-tabs position="top">
                                        <vs-tab :label="$t('Times')" icon="access_time">
                                            <time-table ref="timeTable" :task-id="taskId" :users="users" :canEdit="canEditTask" :project-hours="currentTask.project_hours" :work-types="workTypes"></time-table>
                                        </vs-tab>
                                        <vs-tab :label="$t('Transport')" icon="directions_car">
                                            <transport-table :task-id="taskId" :users="users" :canEdit="canEditTask"></transport-table>
                                        </vs-tab>
                                        <vs-tab :label="$t('Material')" icon="shopping_cart">
                                            <div class="mt-1 pl-2">
                                                <material-table :task-id="taskId" :users="users" :canEdit="canEditTask"></material-table>
                                            </div>
                                        </vs-tab>
                                        <vs-tab :label="$t('Files')" icon="attachment">
                                            <div class="mt-1 pl-2">
                                                <file-table :task-id="taskId" :canEdit="canEditTask"></file-table>
                                            </div>
                                        </vs-tab>
                                        <vs-tab :label="$t('AdditionalNotes')" icon="notes">
                                            <div v-if="currentTask !== undefined" class="mt-1 pl-2">
                                                <vs-button type="border" v-if="currentTask.additional_comment.length === 0 && canEditTask" color="success" @click="activeEditAdditionalNotesPrompt = true">{{$t("Add")}}</vs-button>
                                                <vs-button type="border" v-else-if="canEditTask" color="warning" @click="activeEditAdditionalNotesPrompt = true">{{$t("Edit")}}</vs-button>
                                                <p class="mt-6" style="white-space: pre-wrap">{{currentTask.additional_comment}}</p>
                                            </div>
                                        </vs-tab>
                                    </vs-tabs>
                                </template>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-w="9" class="p-2" vs-sm="12" v-else>
                            <vx-card :title="$t('Times')">
                                <time-table ref="timeTable" :task-id="taskId" :users="users" :canEdit="canEditTask" :project-hours="currentTask.project_hours" :work-types="workTypes"></time-table>
                            </vx-card>
                        </vs-col>

                    </vs-row>
                </vs-col>
                <!--<vs-col vs-w="3" class="p-1" vs-sm="12">
                    <vx-card title="Chat" class="overflow-hidden">
                        <template slot="no-body">
                            <div class="chat-card-log">
                                <VuePerfectScrollbar ref="chatLogPS" class="scroll-area pt-6 px-6" :settings="settings" :key="$vs.rtl">
                                    <ul ref="chatLog">
                                        <li class="flex items-start" :class="{'flex-row-reverse': msg.isSent, 'mt-4': index}" v-for="(msg, index) in chatLog" :key="index">
                                            <div class="msg relative bg-white shadow-md py-3 px-4 mb-2 rounded-lg max-w-md" :class="{'chat-sent-msg bg-primary-gradient text-white': msg.isSent, 'border border-solid d-theme-border-grey-light': !msg.isSent}">
                                                <span>{{ msg.msg }}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </VuePerfectScrollbar>
                            </div>
                            <div class="flex bg-white p-6 chat-input-container">
                                <vs-input class="mr-3 w-full" v-model="chatMsgInput" @keyup.enter="chatMsgInput = ''" placeholder="Type Your Message" ></vs-input>
                                <vs-button icon-pack="feather" icon="icon-send" @click="chatMsgInput = ''"></vs-button>
                            </div>
                        </template>
                    </vx-card>
                </vs-col>-->
            </vs-row>

        <vs-popup :title="$t('Edit')" :active.sync="activeDescriptionPrompt" style="z-index: 54000">
            <div>
                <p>{{$t("TaskTitle")}}</p>
                <vs-input style="width: 100%" class="mb-6" v-model="taskEditTitle"></vs-input>
                <span>{{$t("Description")}}</span>
                <vs-textarea v-model="descriptionEditArea" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveDescription">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeTask">{{$t("Delete")}}</vs-button>

            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="activeEditAdditionalNotesPrompt" style="z-index: 54000">
            <div>
                <span>{{$t("AdditionalNotes")}}</span>
                <vs-textarea v-model="additionalNotesEditArea" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveAdditionalNotes">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Add')" :active.sync="activeAssignUserPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedAssignUser">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in assignableUsers" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="assignUser">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="activeEditContactPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedContact">
                    <vs-select-item :key="index" :value="item.id" :text="item.name + ' ' + item.l_name" v-for="(item,index) in clientContacts" />
                </vs-select>
                <vs-divider/>
                <vs-button :disabled="this.selectedContact.length == 0" color="success" type="border" class="mt-6; mr-1" @click="changeContact">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('StartWithWork')" :active.sync="activeStartWorkPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedStartWorkType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTypeMap" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="startWork">{{$t("StartWithWork")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('StopWithWork')" :active.sync="activeFinishWorkPrompt" style="z-index: 54000">
            <div>
                <span>{{$t("Notes")}}</span>
                <vs-textarea v-model="finishWorkNotes" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="stopWork">{{$t("StopWithWork")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('StartWithTransport')" :active.sync="activeStartTransportPrompt" style="z-index: 54000">
            <div>
                <vs-button :disabled="startTransportButtonDisabled" color="success" type="border" class="mt-6; mr-1" @click="startTransport">{{$t("StartWithTransport")}}</vs-button>
                <vs-divider/>
                <p>{{$t("StartPoint")}}</p>
                <vs-input :disabled="true" style="width: 100%" class="mb-6" v-model="vehicleLastTransport.destination"></vs-input>
                <p>{{$t("Destination")}}</p>
                <vs-input :disabled="true" style="width: 100%" class="mb-6" v-model="branchOffice.address + ', ' + branchOffice.town + ', ' + branchOffice.country"></vs-input>
                <p>{{$t("StartKilometers")}}</p>
                <vs-input type="number" style="width: 100%" class="mb-6" v-model="startTransportKilometers"></vs-input>
                <p>{{$t("Vehicle")}}</p>
                <vs-select class="selectExample mb-6 w-full" v-model="selectedTransportVehicle">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in vehicles" />
                </vs-select>
                <p>{{$t("Passengers")}}</p>
                <vs-select autocomplete multiple class="selectExample w-full" v-model="selectedStartTransportUsers">
                    <vs-select-item v-if="item.id !== $store.getters.userData.id" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                </vs-select>
                <p class="mt-6">{{$t("Comments")}}</p>
                <vs-textarea v-model="startTransportComment" class="w-full" />
            </div>
        </vs-popup>

        <vs-prompt
                @accept="giveTask"
                style="z-index: 54000"
                :title="$t('GiveTask')"
                :active.sync="activeGiveTaskPrompt">
            {{$t("GiveTaskText")}}
        </vs-prompt>

        <vs-popup :title="$t('Edit')" :active.sync="activeEditClientPrompt" style="z-index: 54000">
            <div>
                <p class="mt-6">{{$t("Client")}}</p>
                <vs-select autocomplete class="selectExample w-full" v-model="taskEditClient">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
                </vs-select>
                <p class="mt-6">{{$t("BranchOffice")}}</p>
                <vs-select autocomplete class="selectExample w-full" v-model="taskEditBranchOffice">
                    <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="editClient">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>

    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import TimeTable from "./TimeTable";
    import TransportTable from "./TransportTable";
    import MaterialTable from "./MaterialTable";
    import FileTable from "./FileTable";
    import vSelect from 'vue-select'

    export default {
        components: {
            FileTable,
            MaterialTable,
            TransportTable,
            VuePerfectScrollbar,
            TimeTable,
            'v-select': vSelect,
        },
        data() {
            return {
                taskId: '',
                activeDescriptionPrompt: false,
                activeEditAdditionalNotesPrompt: false,
                activeStartTransportPrompt: false,
                activeEditContactPrompt: false,
                activeAssignUserPrompt: false,
                descriptionEditArea: '',
                taskEditTitle: '',
                additionalNotesEditArea: '',

                activeEditClientPrompt: false,
                taskEditClient: 0,
                taskEditBranchOffice: 0,
                branchOffices: [],

                currentTask: undefined,
                taskClient: {},
                users: {},
                isProject: false,
                calculateRunningTime: false,
                elapsedTime: '',
                assignedUsers: {},
                selectedAssignUser: {},
                giveTaskId: '',
                activeGiveTaskPrompt: false,
                taskStatus: {},
                activeStartWorkPrompt: false,
                selectedStartWorkType: '',
                activeFinishWorkPrompt: false,
                finishWorkNotes: '',
                projectName: '',
                chatLog: [
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-2.jpg"), msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', isSent: false },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Sed sit amet arcu condimentum, consequat eros quis, bibendum magna.', isSent: true },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-2.jpg"), msg: 'Maecenas dignissim, felis eu lacinia finibus, ex ipsum viverra arcu, in interdum dui lacus nec est.', isSent: false },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Donec ut leo non ante lacinia commodo', isSent: true },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-2.jpg"), msg: 'Suspendisse dictum nisi purus, a vehicula lorem accumsan eget', isSent: false },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Maecenas vehicula mauris eu sem feugiat hendrerit. ', isSent: true },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Donec ut leo non ante lacinia commodo', isSent: true },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Sed sit amet arcu condimentum, consequat eros quis, bibendum magna.', isSent: true },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-2.jpg"), msg: 'Suspendisse dictum nisi purus, a vehicula lorem accumsan eget', isSent: false },
                    { senderImg: require("@/assets/images/portrait/small/avatar-s-5.jpg"), msg: 'Sed sit amet arcu condimentum, consequat eros quis, bibendum magna.', isSent: true },
                ],
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                chatMsgInput: '',
                workTypes: [],

                branchOffice: {},
                clientContacts: [],
                selectedContact: '',

                selectedStartTransportUsers: [],
                vehicles: [],
                vehiclesInUse: [],
                selectedTransportVehicle: '',
                vehicleLastTransport: '',
                startTransportKilometers: '',
                startTransportComment: '',

                updateTaskStatusTimer: '',
                calculateTimeTimer: '',

                selectedTags: [],
                editTags: false,

            }
        },
        computed:{
            selectableTags() {

                let tags = [];



                for (let key in this.$store.state.tags) {
                    if (this.$store.state.tags.hasOwnProperty(key)){
                        if(this.$store.state.tags[key].global){
                            tags.push(this.$store.state.tags[key])
                        }
                    }
                }

                if( this.taskClient.tags){
                    for(let x = 0; x < this.taskClient.tags.length; x++) {
                        if(!tags.includes(this.taskClient.tags[x])){
                            tags.push(this.taskClient.tags[x]);
                        }
                    }
                }

                return tags;

            },
            startTransportButtonDisabled: function () {

                if(Number(this.startTransportKilometers) === 0) return true;
                if(this.selectedTransportVehicle.length === 0) return true;
                for(let x = 0; x < this.vehicles.length; x++){
                    if(this.vehicles[x].private_vehicle && this.vehicles[x].id === this.selectedTransportVehicle) return false;
                }
                if(this.vehicleLastTransport) {
                    if(this.vehicleLastTransport.end_kilometers > 0) {
                        if(Math.abs(this.vehicleLastTransport.end_kilometers - Number(this.startTransportKilometers))  > 9) return true;
                    }

                }

                return false;

            },
            taskName: function () {
                if(this.currentTask.title){
                    return this.currentTask.title
                }
                return "Loading"
            },
            workTypeMap: function () {

                let types = {};
                for(let x = 0; x < this.workTypes.length; x++){
                    types[this.workTypes[x].id] = this.workTypes[x];
                }
                return types

            },
            contactsMap: function() {
                let contacts = {};
                for(let x = 0; x < this.clientContacts.length; x++){
                    contacts[this.clientContacts[x].id] = this.clientContacts[x];
                }
                return contacts
            },
            canEditTask: function () {
                if(!this.currentTask) return;
                if(this.$store.getters.userData.id === this.currentTask.company_user_id || this.assignedUserIdList.includes(this.$store.getters.userData.id)) return true;
                return false

            },
            assignedUserIdList: function () {
                let list = [];
                if(this.assignedUsers === undefined) return list;
                for( let x = 0; x < this.assignedUsers.length; x++){
                    list.push(this.assignedUsers[x].user_id)
                }
                return list;
            },
            assignableUsers: function () {
                if(!this.currentTask) return;
                let list = [];
                for (let key in this.users) {
                    if (!this.users.hasOwnProperty(key)) continue;
                    if(!this.assignedUserIdList.includes(this.users[key].id) && this.users[key].id !== this.currentTask.company_user_id){
                        list.push(this.users[key])
                    }
                }

                return list;
            }

        },
        methods:{
            updateTask(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId)
                    .then(function (response) {
                        thisIns.currentTask = response.data;
                        thisIns.selectedTags = JSON.parse(JSON.stringify(response.data.tags));
                        thisIns.descriptionEditArea = response.data.description;
                        thisIns.taskEditTitle = response.data.title;
                        thisIns.additionalNotesEditArea = response.data.additional_comment;
                        thisIns.taskEditClient = response.data.client_company_id;
                        thisIns.taskEditBranchOffice = response.data.branch_office_id;
                        thisIns.$emit('taskLoaded');

                        if(response.data.project > 0) {
                            thisIns.$http.get('/api/v1/project/' + response.data.project)
                                .then(function (response) {
                                    thisIns.projectName = response.data.name;
                                    thisIns.isProject = true;

                                })
                                .catch(function (error) {
                                    thisIns.$vs.notify({
                                        title:'Error',
                                        text: error,
                                        position:'top-right',
                                        color:'danger',
                                        iconPack: 'feather',
                                        icon:'icon-alert-circle'})
                                });
                        }

                        thisIns.$http.get('/api/v1/client/' + thisIns.currentTask.client_company_id)
                            .then(function (response) {
                                thisIns.taskClient = response.data
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    position:'top-right',
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                        thisIns.$http.get('/api/v1/client/' + thisIns.currentTask.client_company_id + "/contacts/")
                            .then(function (response) {
                                thisIns.clientContacts = response.data
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    position:'top-right',
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                        thisIns.$http.get('/api/v1/client/' + thisIns.currentTask.client_company_id + "/branch_offices/" + thisIns.currentTask.branch_office_id)
                            .then(function (response) {
                                thisIns.branchOffice = response.data
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    position:'top-right',
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            position:'top-right',
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.updateAssignedUsers();
            },
            updateTaskStatus(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/status")
                    .then(function (response) {
                        thisIns.taskStatus = response.data;
                        if(thisIns.taskStatus.status === 0){
                            if(!thisIns.calculateRunningTime){
                                thisIns.calculateRunningTime = true;
                                thisIns.elapsedTime = '';

                            }
                        }else{
                            if(thisIns.taskStatus.status === 0) {
                                if (thisIns.calculateRunningTime) {
                                    thisIns.calculateRunningTime = false;
                                    thisIns.elapsedTime = '';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
                        console.log(error)
                    });

                this.$http.get('/api/v1/task/' + this.taskId)
                    .then(function (response) {
                        thisIns.currentTask = response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    });

                this.$http.get('/api/v1/task/' + this.taskId + "/user")
                    .then(function (response) {
                        thisIns.assignedUsers = response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
            },
            updateAssignedUsers(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/user")
                    .then(function (response) {
                        thisIns.assignedUsers = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            position:'top-right',
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            saveDescription(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/description", {
                    description: thisIns.descriptionEditArea,
                    title: thisIns.taskEditTitle,
                }).then(function () {
                    thisIns.updateTask();
                    thisIns.activeDescriptionPrompt = false
                }).catch(function (error) {
                    thisIns.activeNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveTags(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/tags", this.selectedTags
                ).then(function () {
                    thisIns.updateTask();
                    thisIns.editTags = false;
                }).catch(function (error) {
                    thisIns.editTags = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveAdditionalNotes(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/additionalNotes", {
                    additional_comment: thisIns.additionalNotesEditArea
                }).then(function () {
                    thisIns.updateTask();
                    thisIns.activeEditAdditionalNotesPrompt = false
                }).catch(function (error) {
                    thisIns.activeEditAdditionalNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            takeTask(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/take")
                    .then(function () {
                        thisIns.updateTask();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            stealTask(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/steal")
                    .then(function () {
                        thisIns.updateTask();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            assignUser(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/user/" + this.selectedAssignUser, {
                }).then(function () {
                    thisIns.updateAssignedUsers();
                    thisIns.activeAssignUserPrompt = false
                }).catch(function (error) {
                    thisIns.activeAssignUserPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            giveTask: function() {
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/give/" + this.giveTaskId, {
                }).then(function () {
                    thisIns.updateTask()
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeFromTask(id){
                const thisIns = this;
                this.$http.delete('/api/v1/task/' + this.taskId + "/user/" + id, {
                }).then(function () {
                    thisIns.updateAssignedUsers();
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            startWork(){
                const thisIns = this;
                this.$http.post('/api/v1/task/' + this.taskId + "/start", {
                    work_type_id: thisIns.selectedStartWorkType
                }).then(function () {
                    thisIns.activeStartWorkPrompt = false
                }).catch(function (error) {
                    thisIns.activeStartWorkPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            continueWork(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/continue")
                    .then(function () {
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            pauseWork(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/pause")
                    .then(function () {
                        thisIns.$refs.timeTable.updateTimes();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            stopWork(){
                const thisIns = this;
                this.$http.post('/api/v1/task/' + this.taskId + "/stop", {
                    final_notes: thisIns.finishWorkNotes
                }).then(function () {
                    thisIns.$refs.timeTable.updateTimes();
                    thisIns.activeFinishWorkPrompt = false;
                }).catch(function (error) {
                    thisIns.activeFinishWorkPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            calculateTime(){
                if(this.calculateRunningTime){

                    let duration = this.moment.duration(this.moment().diff(this.moment(this.taskStatus.time)));
                    let hours = duration.hours();
                    let minutes = duration.minutes();
                    let seconds = duration.seconds();

                    this.elapsedTime = hours + ":" + minutes + ":" + seconds
                }
            },
            removeTask(){
                const thisIns = this;
                this.$http.delete('/api/v1/task/' + this.taskId, {
                }).then(function () {
                    thisIns.activeDescriptionPrompt = false;
                    thisIns.$nextTick(() => {
                        thisIns.$router.go(-1)
                    });

                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            sendToConfirm(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#confirmButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/close")
                    .then(function () {
                        thisIns.updateTask();
                        thisIns.$vs.loading.close("#confirmButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            text: thisIns.$t("TaskSentForConfirmation"),
                            position:'top-right',
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-check-circle'})
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#confirmButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            getPDFPreview(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#previewButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/preview")
                    .then(function (response) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = "/pdf/task/" + response.data;
                        }else{
                            window.open("/pdf/task/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            changeContact(){
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/contact/" + this.selectedContact, {
                }).then(function () {
                    thisIns.updateTask();
                    thisIns.activeEditContactPrompt = false
                }).catch(function (error) {
                    thisIns.activeEditContactPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            startTransport() {
                const thisIns = this;
                this.$http.post('/api/v1/transport/start', {
                    company_users: this.selectedStartTransportUsers,
                    task_id: Number(this.taskId),
                    kilometers: Number(this.startTransportKilometers),
                    vehicle_id: Number(this.selectedTransportVehicle),
                    comment: this.startTransportComment
                }).then(function () {
                    thisIns.$store.dispatch('updateTransportStarted', true);
                    thisIns.activeStartTransportPrompt = false;
                    thisIns.$nextTick(() => {
                        thisIns.$router.push({ name: 'in-transit' });
                        document.body.style.zoom = "100%";
                    });
                }).catch(function (error) {
                    thisIns.activeStartTransportPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            openStartTransportPrompt() {
                this.activeStartTransportPrompt = true;
                const thisIns = this;
                this.$http.get('/api/v1/vehicle/?type=selectable')
                    .then(function (response) {
                        thisIns.vehicles = response.data;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editClient(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/client", {
                    client_company_id: Number(thisIns.taskEditClient),
                    branch_office_id: Number(thisIns.taskEditBranchOffice),
                }).then(function () {
                    thisIns.updateTask();
                    thisIns.activeEditClientPrompt = false;
                }).catch(function (error) {
                    thisIns.activeEditClientPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        watch:{
            taskEditClient() {
                let thisIns = this;
                this.$http.get('/api/v1/client/' + thisIns.taskEditClient + "/branch_offices/")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        thisIns.taskEditBranchOffice = response.data[0].id
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            position:'top-right',
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            selectedTransportVehicle: function () {
                const thisIns = this;
                this.$http.get('/api/v1/transport/list/vehicle/' + this.selectedTransportVehicle + '/last')
                    .then(function (response) {
                        thisIns.vehicleLastTransport = response.data;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            '$route.params.id': function () {

                clearInterval(this.updateTaskStatusTimer);
                clearInterval(this.calculateTimeTimer);

                this.calculateRunningTime = false;

                this.taskId = Number(this.$route.params.id);

                const thisIns = this;
                this.$http.get('/api/v1/user_names/')
                    .then(function (response) {
                        thisIns.users = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/work_type/')
                    .then(function (response) {
                        thisIns.workTypes = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/vehicle/?type=selectable')
                    .then(function (response) {
                        thisIns.vehicles = response.data;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/transport/vehicle/in_use')
                    .then(function (response) {
                        thisIns.vehiclesInUse = response.data;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.updateTask();
                this.updateTaskStatus();

                this.updateTaskStatusTimer = setInterval(()=>{ this.updateTaskStatus() }, 1000);
                this.calculateTimeTimer = setInterval(()=>{ this.calculateTime() }, 1000);
            }
        },
        beforeDestroy(){
            clearInterval(this.updateTaskStatusTimer);
            clearInterval(this.calculateTimeTimer);
        },
        created() {
            this.taskId = Number(this.$route.params.id);

            const thisIns = this;
            this.$http.get('/api/v1/user_names/')
                .then(function (response) {
                    thisIns.users = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            this.$http.get('/api/v1/work_type/')
                .then(function (response) {
                    thisIns.workTypes = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            this.$http.get('/api/v1/vehicle/')
                .then(function (response) {
                    thisIns.vehicles = response.data;

                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            this.$http.get('/api/v1/transport/vehicle/in_use')
                .then(function (response) {
                    thisIns.vehiclesInUse = response.data;

                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            this.updateTask();
            this.updateTaskStatus();

            this.updateTaskStatusTimer = setInterval(()=>{ this.updateTaskStatus() }, 1000);
            this.calculateTimeTimer = setInterval(()=>{ this.calculateTime() }, 1000);

        },
    }
</script>

<style lang="scss">


    .chat-card-log {
        height: 46rem;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .vs-tabs-position-bottom .vs-tabs--ul, .vs-tabs-position-top .vs-tabs--ul {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap !important;
        justify-content: space-evenly;
    }

    .vs-tabs--li {
        flex-grow: 1 !important;
    }

    .line-vs-tabs {
        display: none;
    }

    .vs-tabs--li.activeChild {
        border-width: 0 0 2px 0;
        border-color: rgba(255, 159, 67, 0.8);
        border-style:solid;
    }

</style>
